/* eslint-disable @typescript-eslint/no-invalid-void-type */
import { apiSlice } from './apiSlice';
import Admin from '../../core/models/Admin';

export const adminApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAdmins: builder.query<Admin[], void>({
      query: () => ({
        url: '/admins',
        method: 'GET',
      }),
      keepUnusedDataFor: 5,
      providesTags: (result, error, arg) =>
        result
          ? [
              ...result.map(({ id }) => ({ type: 'Admin' as const, id })),
              { type: 'Admin', id: 'LIST' },
            ]
          : [{ type: 'Admin', id: 'LIST' }],
    }),
    updateAdmin: builder.mutation<Admin, Admin>({
      query: (data) => ({
        url: '/admins',
        method: data?.id ? 'PUT' : 'POST',
        body: data,
      }),
      invalidatesTags: ['Admin'],
    }),
    deleteAdmin: builder.mutation<void, string>({
      query: (id) => ({
        url: `/admins/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Admin'],
    }),
  }),
});

export const { useGetAdminsQuery, useUpdateAdminMutation, useDeleteAdminMutation } = adminApiSlice;
